import * as React from 'react';

function SvgHddFill(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M0 10a2 2 0 012-2h12a2 2 0 012 2v1a2 2 0 01-2 2H2a2 2 0 01-2-2v-1zm2.5 1a.5.5 0 100-1 .5.5 0 000 1zm2 0a.5.5 0 100-1 .5.5 0 000 1zM.91 7.204A2.993 2.993 0 012 7h12c.384 0 .752.072 1.09.204l-1.867-3.422A1.5 1.5 0 0011.906 3H4.094a1.5 1.5 0 00-1.317.782L.91 7.204z' />
		</svg>
	);
}

export default SvgHddFill;
